import React from 'react';
import PropTypes from 'prop-types';
import useClientNameRenderer from 'src/common/hooks/useClientNameRenderer';

const ContactTitle = ({
  contactData,
  hbh1509ClientsDrawerEnabled,
  onContactClick,
  title = 'Eligibility Assessment for',
}) => {
  if (!contactData) {
    return null;
  }

  return (
    <h2 className="text-2xl font-bold mb-2">
      {title}{' '}
      {
        (() => {
          const { renderClientName } = useClientNameRenderer({
            clientData: contactData,
            onDrawerOpen: onContactClick,
            hbh1509ClientsDrawerP2Enabled: hbh1509ClientsDrawerEnabled,
            additionalProps: {
              textSize: 'text-2xl',
              className: 'mb-2',
              dataTestId: 'eligibility-client-name',
              showArrow: true,
              arrowSize: '20',
            },
          });
          return renderClientName();
        })()
      }
    </h2>
  );
};

ContactTitle.propTypes = {
  contactData: PropTypes.object.isRequired,
  hbh1509ClientsDrawerEnabled: PropTypes.bool.isRequired,
  onContactClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ContactTitle.defaultProps = {
  title: 'Eligibility Assessment for',
};

export default ContactTitle;
